import {MutationTree} from "vuex";
import {UserState} from "./types";

export const mutations: MutationTree<UserState> = {
  setAllowedPages: (state, payload) => {
    state.allowedPages = payload;
  }
}
